export default __webpack_public_path__ + "static/media/img2.e5a57903.png";